import { isIos } from 'src/utils/isIos';
import { isAndroid } from 'src/utils/isAndroid';

export function areWeInsideMobileWrapper(global: Window = window) {
  return isIos(global) || isAndroid(global);
}
